/* eslint-disable no-empty */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable simple-import-sort/imports */
/* eslint-disable react/self-closing-comp */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prettier/prettier */
/* eslint-disable react/button-has-type */
/* eslint-disable react/function-component-definition */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-no-comment-textnodes */

import { useGoogleLogin } from '@react-oauth/google';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../services/api';

// Facebook SDK types
declare global {
  interface Window {
    FB: any;
    fbAsyncInit: () => void;
  }
}

interface FacebookResponse {
  authResponse: {
    accessToken: string;
    userID: string;
  };
  status: string;
}

interface FacebookUserInfo {
  id: string;
  name: string;
  email?: string;
  picture?: {
    data: {
      url: string;
    };
  };
  first_name?: string;
  last_name?: string;
}

// Define Apple response types
interface AppleResponse {
  identityToken: string;
  user: string;
  fullName?: {
    givenName?: string;
    familyName?: string;
  };
  email?: string;
}

export interface SocialUserData {
  given_name?: string;
  family_name?: string;
  name?: string;
  email?: string;
  picture?: string;
}

interface SocialLoginProps {
  onSuccess: (userData: SocialUserData) => void;
  buttonText?: string;
  showOnlyGoogle?: boolean;
}

const SocialLogin: React.FC<SocialLoginProps> = ({
  onSuccess,
  buttonText = 'Continue with Google',
  showOnlyGoogle = false,
}) => {
  const navigate = useNavigate();
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [facebookUserInfo, setFacebookUserInfo] = useState<FacebookUserInfo | null>(null);
  const [facebookAccessToken, setFacebookAccessToken] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleEmailSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const emailInput = (e.currentTarget as HTMLFormElement).elements.namedItem(
      'email'
    ) as HTMLInputElement;
    const email = emailInput.value.trim();

    if (!email) return;

    try {
      setIsLoading(true);
      const response = await api.post('/verify/facebook', {
        email,
        accessToken: facebookAccessToken,
        provider: 'FACEBOOK',
      });

      if (!response.data) {
        throw new Error('Failed to verify email');
      }

      const userData = {
        id: `facebook_${facebookUserInfo?.id}`,
        name: facebookUserInfo?.name || 'Facebook User',
        email,
        picture: facebookUserInfo?.picture?.data?.url || 'https://via.placeholder.com/150',
        provider: 'FACEBOOK',
      };

      localStorage.setItem('user', JSON.stringify(userData));
      localStorage.setItem('lastLoginProvider', 'facebook');
      setShowEmailModal(false);

      onSuccess({
        given_name: facebookUserInfo?.first_name,
        family_name: facebookUserInfo?.last_name,
        name: facebookUserInfo?.name,
        email,
        picture: facebookUserInfo?.picture?.data?.url,
      });
    } catch (error) {
      // Show error message to user
      // eslint-disable-next-line no-alert
      alert('Failed to verify email. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleLogin = useGoogleLogin({
    onSuccess: async tokenResponse => {

      try {
        // Store the Google access token in localStorage for registration
        if (tokenResponse.access_token) {
          localStorage.setItem('SocialLoginToken', tokenResponse.access_token);
          localStorage.setItem('LoginProvider', 'GOOGLE');
        }

        const response = await fetch('https://www.googleapis.com/oauth2/v2/userinfo', {
          headers: {
            Authorization: `Bearer ${tokenResponse.access_token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch user info from Google');
        }

        const userInfo = await response.json();

        const userData = {
          id: `google_${userInfo.id}`,
          name: userInfo.name || 'Google User',
          email: userInfo.email || '',
          picture: userInfo.picture || 'https://via.placeholder.com/150',
          provider: 'GOOGLE',
        };

        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('lastLoginProvider', 'google');

        // Notify parent component about successful login with user data
        onSuccess(userInfo);
      } catch (error) {
        // You might want to show an error message to the user here
      }
    },
    onError: error => {
      // You might want to show an error message to the user here
    },
  });

  const handleAppleLogin = async () => {
    (response: AppleResponse) => {
    try {

      if (response.identityToken) {
        // Store Apple token in localStorage
        localStorage.setItem('SocialLoginToken', response.identityToken);
        localStorage.setItem('LoginProvider', 'APPLE');
        // Create user data from Apple response
        const userData = {
          id: `apple_${response.user}`,
          name: response.fullName
            ? `${response.fullName.givenName || ''} ${response.fullName.familyName || ''}`.trim()
            : 'Apple User',
          email: response.email || '',
          provider: 'apple',
        };

        localStorage.setItem('user', JSON.stringify(userData));
        onSuccess({
          given_name: response.fullName?.givenName,
          family_name: response.fullName?.familyName,
          name: userData.name,
          email: userData.email,
          picture: '', // Apple doesn't provide a picture URL
        });
      }
    } catch (error) {
    }
  }
}

  const handleFacebookLogin = () => {
    if (!window.FB) {
      return;
    }

    window.FB.login(
      (response: FacebookResponse) => {
        if (response.authResponse) {
          // Store Facebook token in state
          const { accessToken } = response.authResponse;
          setFacebookAccessToken(accessToken);
          localStorage.setItem('SocialLoginToken', accessToken);
          localStorage.setItem('LoginProvider', 'FACEBOOK');

          // Get user info from Facebook
          window.FB.api(
            '/me',
            { fields: 'name,picture,first_name,last_name' },
            (userInfo: FacebookUserInfo) => {
              setFacebookUserInfo(userInfo);
              if (userInfo.email) {
                // If email is provided, proceed with login
                const userData = {
                  id: `facebook_${userInfo.id}`,
                  name: userInfo.name || 'Facebook User',
                  email: userInfo.email,
                  picture: userInfo.picture?.data?.url || 'https://via.placeholder.com/150',
                  provider: 'FACEBOOK',
                };

                localStorage.setItem('user', JSON.stringify(userData));
                localStorage.setItem('lastLoginProvider', 'facebook');

                onSuccess({
                  given_name: userInfo.first_name,
                  family_name: userInfo.last_name,
                  name: userInfo.name,
                  email: userInfo.email,
                  picture: userInfo.picture?.data?.url,
                });
              } else {
                // If no email, show the email input modal
                // setShowEmailModal(true);
                throw new Error('Please register or try with some ther social login');
              }
            }
          );
        } 
      },
      { scope: 'email,public_profile' }
    );
  };

  // Initialize Facebook SDK
  useEffect(() => {
    // Load Facebook SDK
    if (!window.FB) {
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: process.env.REACT_APP_FACEBOOK_APP_ID || 'your-facebook-app-id',
          cookie: true,
          xfbml: true,
          version: 'v18.0',
        });
      };

      // Load the SDK asynchronously
      const script = document.createElement('script');
      script.async = true;
      script.defer = true;
      script.crossOrigin = 'anonymous';
      script.src = 'https://connect.facebook.net/en_US/sdk.js';
      document.head.appendChild(script);
    }
  }, []);

  return (
    <div className="w-full">
      <div className="flex items-center justify-center gap-4">
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleFacebookLogin();
          }}
          className="flex items-center justify-center p-[15px] rounded-[10px] bg-[#1877F2] hover:opacity-90 transition-opacity cursor-pointer"
          aria-label="Continue with Facebook"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M23.5 12.0699C23.5 5.7186 18.3513 0.56988 12 0.56988C5.64872 0.56988 0.5 5.7186 0.5 12.0699C0.5 17.8099 4.70538 22.5674 10.2031 23.4302V15.3941H7.2832V12.0699H10.2031V9.53629C10.2031 6.6541 11.92 5.06207 14.5468 5.06207C15.805 5.06207 17.1211 5.28668 17.1211 5.28668V8.11675H15.671C14.2424 8.11675 13.7969 9.00322 13.7969 9.91266V12.0699H16.9863L16.4765 15.3941H13.7969V23.4302C19.2946 22.5674 23.5 17.8099 23.5 12.0699Z" fill="white"/>
          </svg>
        </button>

        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleGoogleLogin();
          }}
          className="flex items-center justify-center p-[15px] rounded-[10px] bg-gray-200 shadow-google-btn cursor-pointer"
          aria-label="Continue with Google"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M23.04 12.2614C23.04 11.4459 22.9668 10.6618 22.8309 9.90912H12V14.3575H18.1891C17.9225 15.795 17.1123 17.013 15.8943 17.8284V20.7139H19.6109C21.7855 18.7118 23.04 15.7637 23.04 12.2614Z" fill="#4285F4"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M12 23.4998C15.105 23.4998 17.7081 22.47 19.6109 20.7137L15.8943 17.8282C14.8645 18.5182 13.5472 18.9259 12 18.9259C9.00474 18.9259 6.46951 16.903 5.56519 14.1848H1.72314V17.1644C3.61542 20.9228 7.50451 23.4998 12 23.4998Z" fill="#34A853"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M5.56523 14.1851C5.33523 13.4951 5.20455 12.758 5.20455 12.0001C5.20455 11.2421 5.33523 10.5051 5.56523 9.81506V6.83551H1.72318C0.944318 8.38801 0.5 10.1444 0.5 12.0001C0.5 13.8557 0.944318 15.6121 1.72318 17.1646L5.56523 14.1851Z" fill="#FBBC05"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M12 5.07386C13.6884 5.07386 15.2043 5.65409 16.3961 6.79364L19.6945 3.49523C17.7029 1.63955 15.0997 0.5 12 0.5C7.50451 0.5 3.61542 3.07705 1.72314 6.83545L5.56519 9.815C6.46951 7.09682 9.00474 5.07386 12 5.07386Z" fill="#EA4335"/>
          </svg>
        </button>

        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleAppleLogin();
          }}
          className="flex items-center justify-center p-[15px] rounded-[10px] bg-black hover:opacity-80 transition-opacity cursor-pointer"
          aria-label="Continue with Apple"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.2807 18.424C20.9328 19.2275 20.5211 19.9672 20.0441 20.6472C19.3939 21.5743 18.8615 22.216 18.4512 22.5724C17.8152 23.1573 17.1337 23.4568 16.404 23.4739C15.8801 23.4739 15.2483 23.3248 14.5129 23.0224C13.7751 22.7214 13.097 22.5724 12.4771 22.5724C11.8268 22.5724 11.1295 22.7214 10.3836 23.0224C9.6365 23.3248 9.03469 23.4824 8.57456 23.498C7.87478 23.5278 7.17728 23.2197 6.48105 22.5724C6.03669 22.1848 5.48087 21.5204 4.81503 20.5791C4.10063 19.5739 3.51329 18.4084 3.05317 17.0795C2.56038 15.6442 2.31335 14.2543 2.31335 12.9087C2.31335 11.3673 2.64642 10.0379 3.31354 8.92385C3.83784 8.029 4.53534 7.32312 5.40832 6.80493C6.2813 6.28674 7.22456 6.02267 8.24036 6.00578C8.79618 6.00578 9.52506 6.1777 10.4308 6.51559C11.334 6.85462 11.914 7.02655 12.1683 7.02655C12.3584 7.02655 13.0026 6.82552 14.0948 6.42473C15.1277 6.05305 15.9994 5.89916 16.7135 5.95978C18.6485 6.11595 20.1023 6.87876 21.0691 8.25303C19.3385 9.30163 18.4824 10.7703 18.4995 12.6544C18.5151 14.122 19.0475 15.3432 20.0938 16.3129C20.568 16.7629 21.0975 17.1107 21.6867 17.3578C21.5589 17.7283 21.4241 18.0832 21.2807 18.424ZM16.8427 0.960131C16.8427 2.11039 16.4224 3.18439 15.5848 4.17847C14.574 5.36023 13.3513 6.04311 12.0254 5.93536C12.0086 5.79736 11.9988 5.65213 11.9988 5.49951C11.9988 4.39526 12.4795 3.21349 13.3331 2.24724C13.7593 1.75801 14.3014 1.35122 14.9587 1.02671C15.6146 0.707053 16.235 0.530273 16.8185 0.5C16.8356 0.653772 16.8427 0.807554 16.8427 0.960116V0.960131Z" fill="white"/>
          </svg>
        </button>
      </div>

      {/* Email Input Modal */}
      {showEmailModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
            <h3 className="text-xl font-semibold text-gray-800 mb-3">Email Required</h3>
            <p className="text-gray-600 mb-4">Please enter your email address to continue:</p>
            <form onSubmit={handleEmailSubmit} className="space-y-4">
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                required
              />
              <div className="flex justify-end space-x-3 pt-2">
                <button
                  type="button"
                  onClick={() => setShowEmailModal(false)}
                  disabled={isLoading}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isLoading}
                  className="px-4 py-2 text-sm font-medium text-white bg-[#2563eb] border border-transparent rounded-md hover:bg-[#2563eb]/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2563eb] disabled:opacity-50"
                >
                  {isLoading ? (
                    <span className="flex items-center">
                      <svg
                        className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      Submitting...
                    </span>
                  ) : (
                    'Submit'
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default SocialLogin;
